import { css } from "@emotion/react";

import { DesignToken } from "@livechat/design-system-react-components";

import { withVar } from "themes/helpers";

export const deactivateButtonStyles = css`
  color: ${withVar(DesignToken.ActionNegativeDefault)};

  &.delete-custom-field-action[aria-disabled="true"] {
    color: ${withVar(DesignToken.ActionNegativeDisabled)};
  }
`;

export const disabledTextStyles = css({
  color: withVar(DesignToken.ContentBasicDisabled),
});

export const disabledActivationButtonStyles = css({
  cursor: "pointer",
});
